import { useState } from 'react';
import { Box, EmailMultiInput, Text } from 'shell/components';

const EmailMultiInputDemo = () => {
    const [inputValue, setInputValue] = useState('');
    const [value, setValue] = useState(['user@example.com']);

    const handleClick = (_, targetIndex) => {
        setValue((current) => current.filter((_, index) => index !== targetIndex));
    };

    return (
        <>
            <Text variant={'sh1'}>EmailMultiInput</Text>
            <Box sx={{ maxWidth: 300 }}>
                <EmailMultiInput
                    inputValue={inputValue}
                    value={value}
                    onClick={handleClick}
                    onChange={setValue}
                    onChangeInput={(e) => setInputValue(e.target.value)}
                />
            </Box>
        </>
    );
};

export default EmailMultiInputDemo;
